import React from 'react';

interface RushTimerProps {
  timeRemaining: number;
  timerDuration: number;
}

export const RushTimer: React.FC<RushTimerProps> = ({ timeRemaining, timerDuration }) => {
  const seconds = Math.ceil(timeRemaining / 1000);
  const progress = timerDuration > 0 ? timeRemaining / timerDuration : 0;

  const getColor = () => {
    if (seconds > 6) return 'var(--rush-purple-mid)';
    if (seconds > 3) return 'var(--rush-warning)';
    return 'var(--rush-wrong)';
  };

  const color = getColor();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-1">
        <span
          className="text-2xl font-bold font-mono tabular-nums"
          style={{ color }}
        >
          {seconds}s
        </span>
      </div>
      <div
        className="w-full h-2 rounded-full overflow-hidden"
        style={{ backgroundColor: 'var(--rush-bg-card)' }}
      >
        <div
          className="h-full rounded-full transition-all"
          style={{
            width: `${progress * 100}%`,
            backgroundColor: color,
            transition: 'width 100ms linear',
          }}
        />
      </div>
    </div>
  );
};
